import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {useSelector } from "react-redux";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { formatDate } from "utils/Utils";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import ConfirmationModal from "views/components/ConfirmationModal";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";
import { structureMasterTableColumns } from "assets/properties/properties";

const Structures = () => {
  const navigate = useNavigate();
  const [rawData, setRawData] = useState([]);
  const [rawDataHierarcy, setRawDataHierarcy] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [template, setTemplate] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deleteStructureId, setDeleteStructureId] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  // submit create function
  const handlecreatestructureSubmit = () => {
    navigate(`/coreservice/structure-create`);
  };
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
  };
  useEffect(()=>{
    GetData()
  },[])
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.MASTER_STRUCTURE_TYPE_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setRawData(result?.data);
      parseIndicatorData(result?.data);
      GetHierarcyData();
    }
  }
  const GetHierarcyData = async () => {
      setCallInProgress(true);
      const result = await apiHandler({
        url: endpoint.MASTER_HIERARCHY_FINDALL,
        authToken: authToken,
      });
      setCallInProgress(false);
      if (result?.data?.error_code) {
        toastUpdate("Error", result?.data?.user_description, true);
      } else {
        setRawDataHierarcy(result?.data);
      }
    };
  // parseindicatordata function
  const parseIndicatorData = (data) => {

    let reportData = [];
    data &&
    data.forEach((structure, index) => {
        let row = {
          code: structure?.code,
          name: structure?.name,
          parentCode: structure?.parentCode,
          action: getIcons(structure?.code),
        };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };
  // icons function
  const getIcons = (code) => {
    return (
      <>
        <IconButton
          aria-label="Edit Structure"
          onClick={() => onClickUpdateData(code)}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          aria-label="Delete Structure"
          onClick={() => onClickDeleteData(code)}
        >
          <DeleteIcon />
        </IconButton>
      </>
    );
  };
  // update function
  const onClickUpdateData = (code) => {
    navigate(`/coreservice/structure-create/` + code);
  };
  // delete function
  const onClickDeleteData = (code) => {
    setConfirmationModalHeader("Structure Type");
    setConfirmationModalMsg("Are you sure you want to delete this entry");
    setDeleteStructureId(code);
    setConfirmationModal(true);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeleteStructureId("");
  };
  const handlePositiveResponse = async () => {
    const dataFound = rawDataHierarcy?.find((item) => item?.masterTypeCode === deleteStructureId);
    if(dataFound){
      toastUpdate("Error", "This Structure Type is associated with Hierarchy. Please delete the associated Hierarchy to delete this Structure Type.", true);
      return false
    }
    const structureid = deleteStructureId;
    handleNegativeResponse();
    setCallInProgress(true);
    // Call API to delete Structure
    const res = await apiHandler({
      url: endpoint.MASTER_STRUCTURE_TYPE_DELETE + structureid,
      method: "DELETE",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate("Success", "Delete Structure Type is successful", true);
      GetData()
    }
  };

  // serach function
  const onSearchChange = (event) => {
    const filteredData = rawData.filter((row) => {
      const val = event.target.value;
      const createDate = formatDate(row.createdDate);
      const updatedDate = formatDate(row.updatedDate);
      return (
        row.code.toLowerCase().includes(val.toLowerCase()) ||
        row.name.toLowerCase().includes(val.toLowerCase()) ||
        // row.structureType.toLowerCase().includes(val.toLowerCase()) ||
        createDate.toLowerCase().includes(val.toLowerCase()) ||
        updatedDate.toLowerCase().includes(val.toLowerCase())
      );
    });
    parseIndicatorData(filteredData);
  };
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <SubHeader
          label="Structures"
          button1="Create Structure Type"
          button1click={handlecreatestructureSubmit}
          onSearchChange={onSearchChange}
          search
          searchLabel="Search For Structure"
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <TableContainer component={Paper} elevation={0}>
          <ColumnGroupingTable
            columns={structureMasterTableColumns}
            rows={selectedTableData}
          />
        </TableContainer>
      </GridItem>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </GridContainer>
  );
};

export default Structures;
